import styled from 'types/theme.types';
import { Tree, Input } from 'antd';
import Button from 'components/common/button';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const TriggerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.popoverTreeSelectorHover};
  }
`;

export const IconContainer = styled.div`
  font-size: 8px;
  color: ${({ theme }) => theme.textColor};
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.sideMenuBackground};
  }
`;

export const LabelContainer = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.textColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;

export const FooterButton = styled(Button)`
  text-align: center;
  height: auto;
  font-weight: 500;
`;

// TreeSelector styled components
export const TreeSelectorContainer = styled.div`
  --tree-selector-width: 280px;
  --add-button-width: 18px;
  --tree-node-gap: 8px;
  --switcher-width: 56px;
  width: var(--tree-selector-width);
  padding: 8px;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.primaryWhite};
`;

export const StyledTree = styled(Tree)`
  flex: 1;
  min-height: 0;

  .ant-tree-list-holder {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.backgroundGray};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.textGray};
      border-radius: 3px;

      &:hover {
        background: ${({ theme }) => theme.sideMenuBackground};
      }
    }
  }

  .ant-tree-list {
    background: ${({ theme }) => theme.primaryWhite};
  }

  .ant-tree-node-content-wrapper {
    padding: 4px 8px;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: ${({ theme }) => theme.popoverTreeSelectorHover};

      button {
        opacity: 1;
        visibility: visible;
      }
    }

    &.ant-tree-node-selected {
      background-color: ${({ theme }) => theme.popoverTreeSelectorHover};
    }
  }

  .ant-tree-title {
    width: 100%;
  }

  .ant-tree-treenode {
    display: flex;
    align-items: flex-start;
    margin: 0;
    padding: 2px 0;
  }

  .ant-tree-switcher {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ant-tree-indent-unit {
    width: 16px;
  }
`;

export const SearchContainer = styled.div`
  margin-bottom: 12px;
`;

export const StyledInput = styled(Input)`
  border-radius: 6px;
`;

export const FooterContainer = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${({ theme }) => theme.separatorGray};
`;

const TreeNodeContainerBase = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tree-node-gap);
  width: 100%;
  font-size: 12px;
`;

const TreeNodeContainerLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--tree-node-gap);
  width: 100%;
  font-size: 12px;
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }

  &:focus {
    color: inherit;
    text-decoration: none;
  }

  &:visited {
    color: inherit;
  }
`;

export { TreeNodeContainerBase, TreeNodeContainerLink };

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--add-button-width);
  height: var(--add-button-width);
  border: none;
  background: ${({ theme }) => theme.whiteColor};
  border-radius: 3px;
  cursor: pointer;
  color: ${({ theme }) => theme.textGray};
  font-size: 12px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  align-self: center;
  opacity: 0;
  visibility: hidden;

  &:active {
    transform: scale(0.95);
  }
`;

export const TreeNodeTitle = styled.div`
  min-width: 0;
  flex: 1;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 1.2;
`;

export const SkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
`;

export const NoDataContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.textGray};
  font-size: 14px;
  gap: 8px;

  .anticon {
    font-size: 16px;
    color: ${({ theme }) => theme.sideMenuBackground};
  }
`;
